import {
    DamageReportStepConfig,
    DamageReportStep,
    damageReportStep,
    DamageDateAndLocationFormStepComponent,
    DamageDescriptionFormStepComponent,
    DamageReportForm,
    FileAttachmentFormStepComponent,
    DamageReportSummaryStepComponent,
} from 'app/customer-portal/damage-reports';

export const electronicDamageReportSteps: DamageReportStepConfig<DamageReportStep>[] = [
    damageReportStep('ort-und-datum', DamageDateAndLocationFormStepComponent),
    damageReportStep(
        'beschreibung',
        DamageDescriptionFormStepComponent,
        undefined,
        (form: DamageReportForm) =>
            form.controls.report.controls.damageDate.valid && form.controls.report.controls.location.valid,
    ),
    damageReportStep(
        'dateien-hochladen',
        FileAttachmentFormStepComponent,
        {
            introduction:
                'Bitte wähle die nötigen Dokumente aus, damit deine Schadensmeldung schnell bearbeitet werden kann.',
            addition: `<p>Bitte füge die folgenden Dokumente bei:</p>
            <ul>
                <li>
                    Kaufrechnung des Geräts vorab digital (bei online Rechnungen, die Original PDF-Datei der Rechnung)
                </li>
            </ul>
            <p class="m-24:t">
                Bei einem Schaden:
            </p>
            <ul>
                <li>
                    Foto des Schadens (Bei Smartphones wenn möglich mit angeschaltetem Display, sodass die IMEI ersichtlich ist)
                </li>
                <li>
                    bei Smartphones mit Schäden auf der Rückseite: kurzes Video mit angeschaltetem Display, ersichtlicher IMEI und
                    dem Schaden auf der Rückseite
                </li>
            </ul>
            <p class="m-24:t">Bei Diebstahl:</p>
            <ul>
                <li>Kopie der polizeilichen Strafanzeige (ein Aktenzeichen ist nicht ausreichend)</li>
                <li>Bei Smartphones Nachweis über den letzten Standort Ihres Smartphones</li>
                <li>Nachweis von Ihnen, dass die Daten auf dem Gerät gelöscht wurden</li>
                <li>Bei Smartphones Nachweis der SIM Karten Sperrung und Neubeantragung</li>
            </ul>`,
        },
        (form: DamageReportForm) => form.controls.report.valid,
    ),
    damageReportStep(
        'zusammenfassung',
        DamageReportSummaryStepComponent,
        undefined,
        (form: DamageReportForm) => form.controls.report.valid,
    ),
];
